import Vue from "vue";
import Vuex from "vuex";
import { setCookie, getCookie } from "../api/cookie";
import { GetBasicMessageCount, GetBasicTodolistCount } from "@/api/user";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebarMenuList: [],
    loading: false,
    token: getCookie("token") || "",
    menulist: getCookie("menulist"),
    // 库存
    storage: getCookie("storage"),
    // 财务
    financial: getCookie("financial"),
    // 资产
    asset: getCookie("asset"),
    basic: getCookie("basic"),
    phone: "",
    userinfo: JSON.parse(window.localStorage.getItem("user")) || null,
    // menu:getCookie('menu') || {},
    breadList: JSON.parse(window.sessionStorage.getItem("breadList")) || [],
    company: JSON.parse(window.sessionStorage.getItem("company")) || {},
    SystemNotileCount: 0,
    ToDoCount: 0,
    message: null,
    todo: null
  },
  getters: {
    Token: (state) => state.token,
    Loading: (state) => state.loading,
    BreadList: (state) => state.breadList,
    AdminCompany: (state) => state.company,
    MessageCount: (state) => state.SystemNotileCount,
    ToDoCount: (state) => state.ToDoCount,
    MessageData: state => state.message,
    ToDoData: state => state.todo,
    UserInfo: state => state.userinfo
  },
  mutations: {
    Menu(state, list) {
      state.sidebarMenuList = JSON.stringify(list);
      sessionStorage.setItem("menu", JSON.stringify(list));
    },
    register(state, phone) {
      state.phone = phone;
    },
    SET_TOKEN(state, token) {
      let cookie = {
        token: token,
      };
      setCookie(cookie, 1);
      // state.token = token;
    },
    userinfo(state, userinfo) {
      state.userinfo = userinfo;
      window.localStorage.setItem("user", JSON.stringify(userinfo));
    },
    SET_LOADING(state, type) {
      state.loading = type;
    },
    SET_BREAD(state, breadList) {
      state.breadList = breadList;
      window.sessionStorage.setItem("breadList", JSON.stringify(breadList));
    },
    SET_COMPANY(state, company) {
      state.company = company;
      window.sessionStorage.setItem("company", JSON.stringify(company));
    },
    async GET_COUNT(state, type) {
      if (type) {
        let res = await GetBasicMessageCount();
        if (res.Code == 0) {
          state.SystemNotileCount = res.Data || 0;
        }
        res = await GetBasicTodolistCount();
        if (res.Code == 0) {
          state.ToDoCount = res.Data || 0;
        }
      }
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SET_TODO(state, message) {
      state.todo = message;
    }
  },
  actions: {},
  modules: {},
});
